@if (allNotifications.length <= 0) {
  <app-empty-state-loading [isLoading]="isLoading">
    <h5 title>
      <strong> There are no Notifications. </strong>
    </h5>
  </app-empty-state-loading>
} @else {
  <div [class]="'flex ' + (panelView ? 'justify-content-start' : 'justify-content-center card')">
    <div class="w-11 py-2">
      @if (!panelView) {
        <div class="flex justify-content-between">
          <div class="flex gap-3">
            <h5>Notifications</h5>
            <p class="text-base">{{ notificationCount }}</p>
            <div class="flex gap-1">
              <p>Unread</p>
              <p-inputSwitch [(ngModel)]="unread" (onChange)="switch()"></p-inputSwitch>
            </div>
          </div>
          <div class="flex gap-2">
            <p-button
              [disabled]="unreadNotifications.length === 0"
              styleClass="p-button-sm"
              (onClick)="markAllAsRead()"
              label="Mark all as read"
              [icon]="'pi pi-check-circle'"
            ></p-button>
          </div>
        </div>
        <p-divider></p-divider>
      }

      <div *ngIf="unread">
        <div *ngFor="let notification of unreadNotifications">
          <div class="grid">
            <div class="col-2 p-3 flex align-items-center">
              <app-avatar-generator
                [name]="notification.moduleType"
                [circleSize]="'normal'"
                [circleColor]="notification.createdBy?.profileBgColor"
                [initialsSize]="'.8'"
                [showName]="false"
              ></app-avatar-generator>
            </div>
            <div class="col-8 text-left">
              <div [class]="!notification.isRead ? 'font-semibold' : ''">
                {{ notification.message }}
                <p-badge [value]="notification.moduleType" />
              </div>
              <div class="text-sm">
                <span class="ml-2">{{ notification.createdBy?.fullname }}</span>

                <b>{{ notification.time }}</b>
              </div>
            </div>
            <div class="col-1 p-3">
              <button class="p-panel-header-icon p-link mr-2" (click)="menu.toggle($event)">
                <span class="pi pi-ellipsis-v"></span>
              </button>
              <p-menu #menu id="config_menu" [model]="notification.menuItems" [popup]="true" appendTo="body" />
            </div>
          </div>
          <p-divider></p-divider>
        </div>
        <p *ngIf="!unreadNotifications.length">No unread notifications.</p>
      </div>
      <div *ngIf="!unread">
        <div *ngFor="let notification of allNotifications">
          <div class="grid">
            <div class="col-auto p-3 flex align-items-center">
              <app-avatar-generator
                [name]="notification.moduleType"
                [circleSize]="'normal'"
                [circleColor]="notification.createdBy?.profileBgColor"
                [initialsSize]="'.8'"
                [showName]="false"
              ></app-avatar-generator>
            </div>
            <div class="col-8">
              <div [class]="!notification.isRead ? 'font-semibold' : ''">
                {{ notification.message }}
                <p-badge [value]="notification.moduleType" />
              </div>
              <small>
                <span class="ml-2">{{ notification.createdBy?.fullname }}</span>
                |
                <b class="ml-2">{{ notification.time }}</b>
              </small>
            </div>
            <div class="col p-3">
              <button class="p-panel-header-icon p-link mr-2" (click)="menu.toggle($event)">
                <span class="pi pi-ellipsis-v"></span>
              </button>
              <p-menu #menu id="config_menu" [model]="notification.menuItems" [popup]="true" appendTo="body" />
            </div>
          </div>
          <p-divider></p-divider>
        </div>
      </div>
    </div>
  </div>
}
